/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@material-ui/core";
import MessageEditor from "components/message-editor";
import { TemplateType } from "types/gql-types";
import { Input } from "components/haven-design/form/inputs";
import { Delta } from "components/message-editor/types";
import { CheckboxWithLabel } from "components/haven-design/form/checkbox";

interface Props {
  setMessage: React.Dispatch<React.SetStateAction<Delta>>;
  messageValue: Delta;
  typePrefix: string;
  setSubject?(e: React.ChangeEvent<HTMLInputElement>): void;
  subject?: string | undefined;
  emailBccAddress?: string | undefined;
  setEmailBccAddress?(e: React.ChangeEvent<HTMLInputElement>): void;
  characterLimit?: number | undefined;
  respondToEmail?: string | null;
  respondToEmailEnabled?: boolean;
  setDefaultEmailEnabled?(): void;
  readOnly?: boolean;
  short?: boolean;
  placeholder?: string;
}

const RespondToCheckbox: React.FC<Props> = ({
  respondToEmail,
  respondToEmailEnabled,
  readOnly,
  setDefaultEmailEnabled,
}: Props) => {
  const label = `Responses sent to: ${respondToEmail}`;
  if (!setDefaultEmailEnabled) return null;
  if (!respondToEmail || respondToEmail.length <= 1) return null;
  return (
    <CheckboxWithLabel
      onChange={setDefaultEmailEnabled}
      name="Default-Respond-To"
      label={label}
      checked={respondToEmailEnabled}
      disabled={readOnly}
    />
  );
};

export const ChannelForm: React.FC<Props> = (props) => {
  const {
    setMessage,
    messageValue,
    typePrefix,
    subject,
    setSubject,
    characterLimit,
    readOnly,
    short,
    placeholder,
  } = props;

  return (
    <>
      {typePrefix === TemplateType.EMAIL && (<>
        <Grid item xs={12} sm={6} lg={4}>
          <Input
            type="text"
            name="subject"
            label="Subject"
            placeholder="Subject"
            value={subject}
            onChange={setSubject}
            disabled={readOnly}
          />

        </Grid>
        <Grid item xs={12} sm={4} lg={3}>
          <RespondToCheckbox {...props}/>
        </Grid>
      </>)}
      <Grid item xs={12}>
        <div className={short ? "ql-short-height" : ""}>
          <MessageEditor
            characterLimit={characterLimit}
            onChange={setMessage}
            toolbarId={typePrefix}
            value={messageValue}
            readOnly={readOnly}
            placeholder={placeholder}
          />
        </div>
      </Grid>
    </>
  );
};
